import React from 'react';
import { makeStyles } from '@material-ui/core';

const useStyles = makeStyles(() => ({
  root: {
    backgroundColor: '#FAFAFB',
    maxWidth: '1100px',
    margin: '0 auto',
    padding: 2,
  },
  certificate: {
    paddingBottom: 0,
    '&:last-child': {
      paddingBottom: 0,
    }
  },
  border: {
    padding: 0,
  },
  innerBorder: {
    border: 'solid 11px #777',
    padding: '5px',
  },
  thinBorder: {
    border: 'solid 2px #999',
    padding: '2px',
  },
  thinBorderTwo: {
    border: 'solid 1px #000',
    padding: '10px',
    backgroundColor: '#B9D6C0',
  },
  thinBorderThree: {
    border: 'solid 1px #000',
    padding: '1px',
    backgroundColor: '#fff',
  },
  thinBorderFour: {
    border: 'solid 1px #999',
    padding: '6px',
    backgroundColor: '#fff',
  },
  innerInnerBorder: {
    border: 'dotted 3px #ccc',
  },
  innerInnerInnerBorder: {
    border: 'dotted 3px #ccc',
  },
  innerInnerSmallBorder: {
    border: 'dotted 2px #ccc',
  },
  innerInnerSmallInnerBorder: {
    border: 'dotted 2px #ccc',
    padding: '5px',
  },
  innerMostThinBorder: {
    border: 'solid 1px #aaa',
    padding: '1px',
    backgroundColor: '#fff',
  },
  innerMostThinBorderTwo: {
    border: 'solid 1px #ccc',
    padding: '0 20px 25px',
    backgroundColor: '#fff',
  },
}));

const CertificateBorder = ({ children }) => {
  const classes = useStyles();

  return (
    <div className={classes.root}>
      <div className={classes.certificate}>
        <div className={classes.border}>
          <div className={classes.innerBorder}>
            <div className={classes.thinBorder}>
              <div className={classes.thinBorderTwo}>
                <div className={classes.thinBorderThree}>
                  <div className={classes.thinBorderFour}>
                    <div className={classes.innerInnerBorder}>
                      <div className={classes.innerInnerInnerBorder}>
                        <div className={classes.innerInnerSmallBorder}>
                          <div className={classes.innerInnerSmallInnerBorder}>
                            <div className={classes.innerMostThinBorder}>
                              <div className={classes.innerMostThinBorderTwo}>
                                {children}
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default CertificateBorder;
